import {
  ConnectionRequestType,
  ConnectionResponseType,
} from '@mm/state/model/ConnectionModel';

export const REQUEST_TYPE_OPTIONS = {
  [ConnectionRequestType.GET]: {
    id: ConnectionRequestType.GET,
    key: ConnectionRequestType.GET,
    name: 'GET',
  },
  [ConnectionRequestType.POST]: {
    id: ConnectionRequestType.POST,
    key: ConnectionRequestType.POST,
    name: 'POST',
  },
};

export const RESPONSE_TYPE_OPTIONS = {
  [ConnectionResponseType.NONE]: {
    id: ConnectionResponseType.NONE,
    key: ConnectionResponseType.NONE,
    name: 'None',
  },
  [ConnectionResponseType.SAVE_ATTRIBUTES]: {
    id: ConnectionResponseType.SAVE_ATTRIBUTES,
    key: ConnectionResponseType.SAVE_ATTRIBUTES,
    name: 'Attributes to save',
  },
  [ConnectionResponseType.MESSENGER_JSON]: {
    id: ConnectionResponseType.MESSENGER_JSON,
    key: ConnectionResponseType.MESSENGER_JSON,
    name: 'Messenger JSON to Display',
  },
};
